export default "<h2 class=\"mat-h2\">{{ reportExplanation.name }}</h2>\n<div class=\"mat-body-1\" [innerHtml]=\"reportExplanation.explanation\"></div>";